import React from 'react';
import FillHeightContainer from '@components/misc/FillHeightContainer';
import { CDN_URL } from '@utils/constants/url.constants';
import { useIsJCUser } from '@hooks/user.hook';

const ExamResultEmptyState = () => {
  const { isJC } = useIsJCUser({ subjectId: undefined, generalPage: true });
  return (
    <FillHeightContainer bottomOffset={300}>
      <div
        className={
          'relative w-full h-full text-neutral-whiteboard max-w-fit ml-auto mr-auto'
        }
      >
        <div className={'max-w-[343px]'}>
          {isJC === false && (
            <img
              src={CDN_URL + 'assets/images/empty-state-exam-result.svg'}
              alt={''}
              className={
                'w-[250px] max-w-full block mx-auto my-2 max-sm:w-[180px] max-sm:!mb-1'
              }
            />
          )}
          <div
            className={
              'text-xl font-bold leading-7 text-center mb-3 max-sm:text-md'
            }
          >
            No Exam Results Yet
          </div>
          <div className={'leading-6 text-center max-sm:text-sm'}>
            You got your exam result yet? Upload them here to save your
            achievements. Our teacher will review and verify your exam results
            once we've got it from you
          </div>
        </div>
      </div>
    </FillHeightContainer>
  );
};

export default ExamResultEmptyState;
